export const paylaterAuthenticateURL = 'v1/identity/pii-authenticate'
export const authenticateURL = 'v1/identity/authenticate'
export const activationAuthenticateURL = 'v1/identity/quick-authenticate'
